export default "__VITE_ASSET__BooaKl6C__"